export default __webpack_public_path__ + "static/media/bg5.df1c8203.jpg";